import '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export function getDataValidate(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/points/list/validate', data, { params: new_params })
}

export function hitPoint(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/points/validate', data, { params: new_params })
}

export function calculatePoint(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/points/calculate', data, { params: new_params })
}
